import {RFValue} from 'react-native-responsive-fontsize';
import styled, {css} from 'styled-components/native';

interface Props {
  rank?: 'gold' | 'silver';
}

export const Container = styled.TouchableOpacity<Props>`
  padding: ${RFValue(4)}px; ${RFValue(12)}px;
  border-radius: ${RFValue(8)}px;
  align-items: center;
  justify-content: center;
  margin-right: ${RFValue(12)}px;
  flex-shrink: 0;
  background-color: ${({theme}) => theme.colors.alert};

  ${({rank, theme}) =>
    rank === 'gold' &&
    css`
      border: 1px solid #ffd064;
      background-color: #ffd064;
    `}
  ${({rank, theme}) =>
    rank === 'silver' &&
    css`
      border: 1px solid #c6c6c6;
      background-color: #c6c6c6;
    `};
`;

export const FilterText = styled.Text<Props>`
  font-size: ${RFValue(12)}px;
  color: ${({theme}) => theme.colors.text_dark};
  font-family: ${({theme}) => theme.fonts.semibold};

  ${({rank, theme}) =>
    rank === 'gold' &&
    css`
      color: ${theme.colors.gold_text};
    `}
  ${({rank, theme}) =>
    rank === 'silver' &&
    css`
      color: ${theme.colors.silver_text};
    `}
`;
